import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import ListSubheader from '@mui/material/ListSubheader';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select, { SelectProps } from '@mui/material/Select';
import { forwardRef, ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export type TMultiselectItem<T = unknown> = {
  id: string | number;
  name: string;
  value: string | number | T;
};

type TProps = SelectProps & {
  name: string;
  native?: boolean;
  helperText?: React.ReactNode;
  children: ReactNode | ReactNode[];
};

export const RHFSelect = forwardRef<HTMLDivElement, TProps>((props, ref) => {
  const { name, label, helperText, children, native, ...others } = props;

  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <FormControl fullWidth ref={ref}>
            <InputLabel shrink={!!field.value || field.value === 0} id={`label-${name}`}>
              {label}
            </InputLabel>
            <Select
              {...field}
              name={name}
              labelId={`label-${name}`}
              label={label}
              native={native}
              input={<OutlinedInput label={label} notched={!!field.value || field.value === 0} />}
              fullWidth
              {...others}
            >
              <ListSubheader>Select an Option</ListSubheader>
              {children}
            </Select>
            {(!!error || helperText) && (
              <FormHelperText error={!!error}>{error ? error?.message : helperText}</FormHelperText>
            )}
          </FormControl>
        );
      }}
    />
  );
});
